import { render, staticRenderFns } from "./remove-prod.vue?vue&type=template&id=6e42ba92&scoped=true"
import script from "./remove-prod.vue?vue&type=script&lang=js"
export * from "./remove-prod.vue?vue&type=script&lang=js"
import style0 from "./remove-prod.vue?vue&type=style&index=0&id=6e42ba92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e42ba92",
  null
  
)

export default component.exports